import AriaIcon from './component'

export default AriaIcon
